module.exports = "<div class=\"limit-warning-container\" *ngIf=\"isLoggedIn && utilizationPercentage > limitWarningPercent\">\n  <div>\n    <h5 class=\"limit-warning-text\">\n      <img class=\"warning-icon\" src=\"/assets/img/warning-icon.svg\"/>\n      Heads up! You have a monthly limit of {{replyLimit}} replies, which you have exceeded for over 90 days. Reach out to <a class=\"support-email-link\" href=\"mailto:support@drift.com\">support@drift.com</a> to learn more.\n    </h5>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/limit-warning/limit-warning.component.html
// module id = ./client/app/limit-warning/limit-warning.component.html
// module chunks = main